(function () {
  class StrixCartServices extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.strix-cart-service-row__checkbox').forEach((checkbox) => {
        checkbox.addEventListener('change', this.handleToggle.bind(this));
      });
    }

    getSectionIds() {
      return ['cart-items', 'cart-footer']
        .map((suffix) => {
          const section = document.querySelector(
            `[id^="shopify-section-"][id$="${suffix}"]`
          );

          return section
            ? section.id.replace('shopify-section-', '')
            : null;
        })
        .filter(Boolean);
    }

    async handleToggle(event) {
      const checkbox = event.target;
      const row = checkbox.closest('.strix-cart-service-row');

      if (!row) return;

      const serviceVariantId = row.dataset.serviceVariantId;
      const serviceLineKey = row.dataset.serviceLineKey;
      const parentVariantId = this.dataset.parentVariantId;
      const parentQuantity = parseInt(this.dataset.itemQuantity || '1', 10);
      const sectionIds = this.getSectionIds();

      row.classList.add('is--loading');
      checkbox.disabled = true;

      try {
        let response;

        if (checkbox.checked) {
          response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(serviceVariantId, 10),
                  quantity: parentQuantity,
                  properties: {
                    _parent_variant_id: parentVariantId
                  }
                }
              ],
              sections: sectionIds
            })
          });
        } else {
          if (!serviceLineKey) {
            throw new Error('Missing service line key');
          }

          response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: serviceLineKey,
              quantity: 0,
              sections: sectionIds
            })
          });
        }

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Failed to update service'
          );
        }

        if (!data.sections) {
          throw new Error('Missing cart sections');
        }

        this.updateSections(data.sections, sectionIds);

      } catch (error) {
        console.error('strix-cart-services:', error);

        checkbox.checked = !checkbox.checked;
        checkbox.disabled = false;
        row.classList.remove('is--loading');
      }
    }

    updateSections(sections, sectionIds) {
      const parser = new DOMParser();

      sectionIds.forEach((sectionId) => {
        const sectionHtml = sections[sectionId];

        if (!sectionHtml) return;

        const parsedDocument = parser.parseFromString(
          sectionHtml,
          'text/html'
        );

        const newSection = parsedDocument.querySelector(
          `#shopify-section-${sectionId}`
        );

        const currentSection = document.getElementById(
          `shopify-section-${sectionId}`
        );

        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
        }
      });
    }
  }

  if (!customElements.get('strix-cart-services')) {
    customElements.define('strix-cart-services', StrixCartServices);
  }


  /*
   * Radsatz zusammen mit allen zugehörigen
   * Zusatzleistungen aus dem Warenkorb entfernen.
   */
  if (!window.strixCartParentRemovalInitialized) {
    window.strixCartParentRemovalInitialized = true;

    document.addEventListener('click', async function (event) {
      const removeLink = event.target.closest('cart-remove-button a');

      if (!removeLink) return;

      const cartItem = removeLink.closest('.cart-item');

      if (!cartItem) return;

      const servicesElement = cartItem.querySelector('strix-cart-services');

      /*
       * Hat der Artikel keine Zusatzleistungen,
       * lassen wir Shopifys normales Löschverhalten unverändert.
       */
      if (!servicesElement) return;

      const activeServiceRows = Array.from(
        servicesElement.querySelectorAll(
          '.strix-cart-service-row[data-service-line-key]'
        )
      );

      /*
       * Sind aktuell keine Zusatzleistungen gebucht,
       * muss ebenfalls nichts Besonderes passieren.
       */
      if (activeServiceRows.length === 0) return;

      const quantityInput = cartItem.querySelector(
        '.quantity__input[data-item-key]'
      );

      if (!quantityInput) return;

      const parentLineKey = quantityInput.dataset.itemKey;

      if (!parentLineKey) return;

      /*
       * Ab hier übernehmen wir das Löschen selbst,
       * weil Parent + Zusatzleistungen gemeinsam
       * entfernt werden müssen.
       */
      event.preventDefault();
      event.stopPropagation();

      const serviceLineKeys = activeServiceRows
        .map((row) => row.dataset.serviceLineKey)
        .filter(Boolean);

      const updates = {};

      updates[parentLineKey] = 0;

      serviceLineKeys.forEach((serviceLineKey) => {
        updates[serviceLineKey] = 0;
      });

      const sectionIds = ['cart-items', 'cart-footer']
        .map((suffix) => {
          const section = document.querySelector(
            `[id^="shopify-section-"][id$="${suffix}"]`
          );

          return section
            ? section.id.replace('shopify-section-', '')
            : null;
        })
        .filter(Boolean);

      cartItem.classList.add('is--loading');

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: updates,
            sections: sectionIds
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Failed to remove cart item and services'
          );
        }

        if (!data.sections) {
          throw new Error('Missing cart sections');
        }

        const parser = new DOMParser();

        sectionIds.forEach((sectionId) => {
          const sectionHtml = data.sections[sectionId];

          if (!sectionHtml) return;

          const parsedDocument = parser.parseFromString(
            sectionHtml,
            'text/html'
          );

          const newSection = parsedDocument.querySelector(
            `#shopify-section-${sectionId}`
          );

          const currentSection = document.getElementById(
            `shopify-section-${sectionId}`
          );

          if (newSection && currentSection) {
            currentSection.innerHTML = newSection.innerHTML;
          }
        });

      } catch (error) {
        console.error('strix-cart-services parent removal:', error);

        cartItem.classList.remove('is--loading');
      }
    });
  }
})();